// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon, { ICON_SIZE_16 } from '../Icon';

/**
 * `MenuBaseItem` component.
 */
const MenuBaseItem = ({ baseClassName, className, children, icon, label, ...props }) => (
    <li
        className={classNames(
            baseClassName,
            className,
        )}
        {...props}
    >
        <div className={`${baseClassName}-icon`}>
            {Icon.create(icon, { size: ICON_SIZE_16 })}
        </div>
        <div className={`${baseClassName}-content`}>
            {children}
        </div>
        <div className={`${baseClassName}-label`}>
            {label}
        </div>
    </li>
);

MenuBaseItem.propTypes = {
    /**
     * Icon
     */
    icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.element,
    ]),
    /**
     * Right label of item.
     */
    label: PropTypes.node,
    /**
     * Content of the `MenuBaseItem`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

MenuBaseItem.defaultProps = {
    icon: null,
    label: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}menu__base-item`,
};

export default MenuBaseItem;



// WEBPACK FOOTER //
// ./components/Menu/MenuBaseItem.js